import { render, staticRenderFns } from "./RequestCard.vue?vue&type=template&id=a67c8658&"
import script from "./RequestCard.vue?vue&type=script&lang=js&"
export * from "./RequestCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports